import React from 'react'
import Style from './IncidentFeed.module.css'
import PhishingDetectionsRing from './PhishingDetectionsRing'
import DailyActivityGrid from './DailyActivityGrid'
import ComingSoon from './ComingSoon'

// Incident Feed → Overview tab (PIXMC-6521).
//
// Presentational only: IncidentFeed.jsx owns the data fetching and passes everything in,
// which keeps this file testable without a store and keeps one place responsible for the
// window that all three calls share.
//
// D-9: every element the wireframe shows is present from day one. The three sibling stat
// cards, the middle trend panel and Highest risk users are Coming Soon placeholders owned
// by their own stories.
const Overview = (props) => {
  const {
    windowLabel,
    overview, overviewLoading, overviewError,
    phishingDetections, phishingDetectionsLoading, phishingDetectionsError,
    pagesScanned, pagesScannedLoading, pagesScannedError,
  } = props

  return (
    <>
      <div className={Style.sectionTitle}>
        Organization overview
        <span className={Style.sectionWindow}>{windowLabel}</span>
      </div>

      <div className={Style.statRow}>
        <PhishingDetectionsRing
          overview={overview}
          loading={overviewLoading}
          error={overviewError}
          windowLabel={windowLabel}
        />
        <ComingSoon
          variant="statCard"
          label="Policy violations"
          note="Data, Web and AI control violations."
          ticket="PIXMC-6503"
        />
        <ComingSoon
          variant="statCard"
          label="Credential risks"
          note="Compromised, weak and reused credentials."
          ticket="PIXMC-6504"
        />
        <ComingSoon
          variant="statCard"
          label="SaaS usage"
          note="Sanctioned, unsanctioned and denied apps."
          ticket="PIXMC-6502"
        />
      </div>

      <DailyActivityGrid
        windowLabel={windowLabel}
        phishingDetections={phishingDetections}
        phishingDetectionsLoading={phishingDetectionsLoading}
        phishingDetectionsError={phishingDetectionsError}
        pagesScanned={pagesScanned}
        pagesScannedLoading={pagesScannedLoading}
        pagesScannedError={pagesScannedError}
      />

      <div className={Style.card}>
        <div className={Style.cardHeader}>
          <div className={Style.cardTitle}>
            Highest risk users
            <span className={Style.cardSub}>Top 10 by combined risk score</span>
          </div>
        </div>
        <ComingSoon
          variant="section"
          note="Per-user risk scoring across phishing, policy and credential signals."
          ticket="PIXMC-6505"
        />
      </div>
    </>
  )
}

export default Overview
